const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const pad = (value: number): string => ('0' + value).slice(-2)

/**
 * Formats an API timestamp as `dd MMM yyyy HH:mm` in the browser's local time.
 * API timestamps are UTC (AppDbContext stamps UpdatedOn with DateTime.UtcNow) but are serialised
 * without a zone designator once read back from the database, so a value with no `Z`/offset is
 * read as UTC rather than local — same convention as dateToAEST.
 */
export const dateToLocalDateTimeString = (
  incomingDate: string | Date | null | undefined,
): string => {
  if (!incomingDate) return ''
  const raw =
    typeof incomingDate === 'string'
      ? incomingDate.trim()
      : incomingDate.toISOString()
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(raw)
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(raw)
  const date = new Date(
    hasZone ? raw : dateOnly ? `${raw}T00:00:00Z` : `${raw}Z`,
  )
  if (Number.isNaN(date.getTime())) return ''
  return `${pad(date.getDate())} ${
    MONTHS[date.getMonth()]
  } ${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export default dateToLocalDateTimeString
